<template>
  <div class="page-top-space"></div>
  <UserTable/>
</template>

<script>
    import UserTable from "@/components/tables/UserTable.vue";

    export default {
        name: 'UserListView',
        components: {
          UserTable
        }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  h1
    color: THEME_COLOR_PRIMARY
    span
      color: THEME_COLOR_PRIMARY_FADDED
</style>

<style lang="stylus">
  main
    align-content start
</style>